import FaiTypography from "../MuiComponents/FaiTypography";
import FaiBox from "../MuiComponents/FaiBox";


import Home from "../screens/Home";

import Inventory from "../screens/Catalog/Inventory";
import AddProduct from "../screens/Catalog/AddProductForm"
import Draft from "../screens/Catalog/Draft";

import Reports from "../screens/Reports";

import HelpAndSupport from "../screens/HelpAndSupport/RaisedIssues";
import CustomerTickets from "../screens/HelpAndSupport/CustomerTickets";
import RaiseTicket from "../screens/HelpAndSupport/RaiseTicket";
import ClosedIssues from "../screens/HelpAndSupport/ClosedIssues";

import CustomerFeedback from "../screens/CustomerFeedback";

import CouponList from "../screens/Promotions/CouponList";
import CouponForm from "../screens/Promotions/CouponForm";
import Sales from "../screens/Promotions/Sales";
import ContactInformation from "../screens/OnBoarding/ContactInformation";
import BankDetails from "../screens/OnBoarding/BankDetails";
import BusinessDetails from "../screens/OnBoarding/BusinessDetails";
import BrandDetails from "../screens/OnBoarding/BrandDetails";
import LogisticDetails from "../screens/OnBoarding/LogisticDetails";

import Orders from "../screens/OrdersAndReturns/Orders";
import Returns from "../screens/OrdersAndReturns/Returns";
import Refunds from "../screens/OrdersAndReturns/Refunds";

import Payments from "../screens/Payments";

const routes = [
    {
        type: "collapse",
        name: "Home",
        key: "home",
        route: "/app/home",
        component: <Home/>,
        noCollapse: true,
    },

    {
        type:"collapse",
        name: "On Boarding",
        key :"onboarding",
        icon: <FaiBox component="i" color="inherit" fontSize="14px" className="ni ni-align-left-2"/>,

        collapse: [
            {
                name:"Contact Information",
                key: "contactinformation",
                route:"/app/onboarding/contactinformation",
                component: <ContactInformation/>
            },
            {
                name:"Business Details",
                key: "businessdetails",
                route:"/app/onboarding/businessdetails",
                component: <BusinessDetails/>
            },
            {
                name:"Bank Details",
                key: "bankdetails",
                route:"/app/onboarding/bankdetails",
                component: <BankDetails/>
            },
            {
                name:"Brand Details",
                key: "brandDetails",
                route:"/app/onboarding/brandDetails",
                component: <BrandDetails/>
            },
            {
                name:"Logistics Details",
                key: "logisticsdetails",
                route:"/app/onboarding/logisticsdetails",
                component: <LogisticDetails/>
            },
        ]
    },
    {
        type: "collapse",
        name: "Catalog Management",
        key: "catalog",
        collapse: [
            {
                name: "Inventory",
                key: "inventory",
                route: "/app/catalog/inventory",
                component: <Inventory/>,
            },
            {
                name: "Add Product",
                key: "add-product",
                route: "/app/catalog/add-product",
                component: <AddProduct/>,
            },
            {
                name: "Draft",
                key: "draft",
                route: "/app/catalog/draft",
                component: <Draft/>,
            }
        ],
    },
    {
        type: "collapse",
        name: "Orders & Returns",
        key: "orderandreturns",
        collapse: [
            {
                name: "Order",
                key: "order",
                route: "/app/orderandreturns/order",
                component: <Orders/>,
            },
            {
                name: "Returns",
                key: "return",
                route: "/app/orderandreturns/return",
                component: <Returns/>,
            },
            {
                name: "Refunds",
                key: "refund",
                route: "/app/orderandreturns/refund",
                component: <Refunds/>,
            }
        ],
    },

    {
        type: "collapse",
        name: "Customer Feedback",
        key: "customerfeedback",
        route: "/app/customerfeedback",
        component: <CustomerFeedback/>,
        noCollapse: true,
    },

    {
        type: "collapse",
        name: "Promotions",
        key: "promotions",
        collapse: [
            {
                name: "Coupons",
                key: "Coupons",
                route: "/app/promotions/Coupons",
                component: <CouponList/>,
            },
            {
                name: "Add Promotion",
                key: "add-promotion",
                route: "/app/promotions/add-promotion",
                component: <CouponForm/>,
            },
            {
                name: "Sales",
                key: "sales",
                route: "/app/promotions/sales",
                component: <Sales/>,
            },
        ],
    },

    {
        type: "collapse",
        name: "Payments",
        key: "payments",
        route: "/app/payments",
        component: <Payments/>,
        noCollapse: true,
    },

    {
        type: "collapse",
        name: "Reports",
        key: "reports",
        route: "/app/reports",
        component: <Reports/>,
        noCollapse: true,
    },

    {
        type: "collapse",
        name: "Help & Support",
        key: "helpandsupport",
        collapse: [
            {
                name: "Customer Tickets",
                key: "customerTickets",
                route: "/app/helpandsupport/customerTickets",
                component: <CustomerTickets/>,
            },
            {
                name: "Raised Issues",
                key: "raisedIssue",
                route: "/app/helpandsupport/raisedIssue",
                component: <HelpAndSupport/>,
            },
            {
                name: "Raise Ticket",
                key: "raiseTicket",
                route: "/app/helpandsupport/raiseTicket",
                component: <RaiseTicket/>,
            },
            {
                name: "Closed Issues",
                key: "closedIssues",
                route: "/app/helpandsupport/closedIssues",
                component: <ClosedIssues/>,
            }
        ],
    },
]

export default routes;
